export const i18n = {
  defaultLocale: 'uk',
  locales: ['uk', 'en', 'ru'],
};
